export default __webpack_public_path__ + "static/media/Arrow.cd005bec.svg";